import { render, staticRenderFns } from "./CreateAlert.vue?vue&type=template&id=6de3b636"
import script from "./CreateAlert.vue?vue&type=script&lang=js"
export * from "./CreateAlert.vue?vue&type=script&lang=js"
import style0 from "./CreateAlert.vue?vue&type=style&index=0&id=6de3b636&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports